import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Ignore browser-extension promise rejections (Norton, password managers, etc.) so they
// don't bubble to React's error boundary as false "Algo salió mal".
window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  const reason = event.reason;
  const msg =
    typeof reason === 'string'
      ? reason
      : reason?.message != null
        ? String(reason.message)
        : '';
  const stack = typeof reason === 'object' && reason && 'stack' in reason ? String(reason.stack) : '';
  const combined = `${msg} ${stack}`;
  if (
    combined.includes('message channel closed') ||
    combined.includes('listener indicated an asynchronous response') ||
    stack.includes('rum:') ||
    stack.includes('chrome-extension://') ||
    stack.includes('moz-extension://') ||
    stack.includes('safari-web-extension://')
  ) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<App />);

